<template>
    <div id="modal" class="modal modal_size">
        <!-- <OBJECT ID="TrustNETCAClient" ref="CAClient" CLASSID="clsid:C4A97BC6-0E15-46C1-9A7D-2E9465E51C48" width=0 height=0
            CODEBASE='/static/setup/SecuiGSPNIE.cab#Version=1,0,0,1' onerror="alert('LOAD FAILED')">
        </OBJECT> -->
        <!-- <OBJECT id="unetTS" ref="unetTS" classid="clsid:1F529230-5B55-4C17-80A0-70F19821A033"
            width="0" height="0" codebase="/static/setup/SecuiGSPNIE.cab#Version=4,0,0,7" onerror="alert('Module Error');"
        ></OBJECT> -->
        <!--     
        var trustnetCASObj; -->
        <!-- trustnetCASObj = document.getElementById("TrustNETCAClient"); -->
        <a
            href="javascript:"
            class="ui_close"
            type="button"
            rel="modal:close"
            @click="$emit('close')"
        >
            <span class="sr_only">popup close</span>
        </a>
        <dl class="modal_content">
            <dt class="ellipsis maintit">
                <i>Redeem Certificate</i>
            </dt>
            <div
                class="modal_txt"
            >To redeem certificate, please enter the PIN and certificate password, and then, click the 'Confirm' button.</div>
            <ul class="w100 mt-10">
                <li>
                    <span class="clearable">
                        <input
                            type="text"
                            class="text_input w100"
                            placeholder="Pin Number"
                            minlength="8"
                            maxlength="8"
                            v-model="pin"
                            v-validation
                            v-clearable
                        />
                    </span>
                </li>
                <li class="mt-10">
                    <span class="clearable">
                        <input
                            type="password"
                            class="text_input w100"
                            placeholder="Certificate Password"
                            minlength="4"
                            maxlength="20"
                            v-model="password"
                            v-validation
                            v-clearable
                        />
                    </span>
                </li>
                <li class="mt-10">
                    <span class="clearable">
                        <input
                            type="password"
                            class="text_input w100"
                            placeholder="Confirm Certificate Password"
                            minlength="4"
                            maxlength="20"
                            v-model="passwordConfirm"
                            v-validation
                            v-clearable
                        />
                    </span>
                </li>
            </ul>

            <div class="btn_wrap topLine">
                <div class="btn_right pc_only">
                    <a href="javascript:" class="btn_white" title @click="$emit('close')">Cancel</a>
                    <a href="javascript:" class="btn_blue" title @click="onSubmitButtonClick">Confirm</a>
                </div>
            </div>
        </dl>
    </div>
</template>


<script>
import Vue   from 'vue';
import axios from 'axios';
import { SDLUtil, DateUtil, CertUtil } from '@/utils';

import qs from 'query-string';
import { EventBus } from '@/utils/EventBus';
import * as unet from '/static/js/trustnet/TrustNetJsEX';

export default {
    name: 'hhp-cert-issue',
    components: {},
    props: [],
    data() {
        return {
            macAddress: '',
            pin: '',
            password: '',
            passwordConfirm: '',            
        };
    },
    computed: {},

    created() {
        this.init();
    },
    
    mounted() {
//     	let CAS_PATH = 'https://skp.samsungcsportal.com/static/js/trustnet/';
//         if (process.env.NODE_ENV === 'prod') {
//     		let CAS_PATH = 'https://skp.samsungcsportal.com/static/js/trustnet/';
//         }
    	let CAS_PATH = 'https://skp.samsungcsportal.com/static/js/trustnet/';
    	let lrapi_url = CAS_PATH + 'do_lrapi.jsp';//http://skp.samsungcsportal.com:8888/static/js/trustnet/do_lrapi.jsp
    	let webgw_url = CAS_PATH + 'do_webgw.jsp';//http://skp.samsungcsportal.com:8888/static/js/trustnet/do_webgw.jsp
    	
		//////////////////// 라이선스 설정 ////////////////////////////
// 		const time = "20230229";
// 		const access = ["10.199.114.112", "localhost"];
// 		const signature = "shxoiWov1m6E7CKpwBBugMCWGSMrd7778r+Rg/ktJYQWRNUy0DOQcYCeubnf0fNhJ1JRg0TH6nLXQfet6QKXI7fcUHpR7meXFWR80RrhBukRuXhdIc0xaj99u6cjaEgyWWX5pgTrQr206IfNbsJTHFskdgAf180wkyIaVbpt/aFZRBwyHHbi4ywnfjoZpU/VJsHBhLy3vMQ/r27/x94Ep5NgYN71AUUTlG3deaddNt4mVKtLavOM0RBiQeHiJ7wdPAEn/ie04Zrosx0RvNMjvWUZ6lGlU/uSCvX1WIGYiQ0Hlt3g5788n/Tm7g/7vXx3KhwDrJbYfaekx+oKMkRZcQ==";
//         if (process.env.NODE_ENV === 'prod') {
		const time = "permanent";
		const access = ["skp.samsungcsportal.com"];
		const signature = "uRfuldEhY0RL5LdYgEX1OlTcsNVSN+Mmxmxocb+BbX1Xl8gdj97VmK64FQghgvTaTc6bygJ2VJ8bV1ebgUpz1ViP2/pqP+8XRmaYjP/iN8KSFD3BWfLcygoXxWrX+sjANANt78lsA8Qs+1BfrsLuOUYtYvbcVngydnGT9fGn5j35geR38DnkUKpjNmM69w2R5F0cW1jno4wwHoiSfgJjAOsfhmvWKtadG5H+wwKsdkTAvyqGQlmZKgohMGoYNApcFrKW3PLKd4cNpw+GTH0p9j2pPVtBcuUTT7f1tTVDFp8zU7HGEChqctsXDSoSdDMCMiyGWJZizBLdJvfepeUXnQ==";
//         }
		const LICENSE = {"time":time, "access":access, "signature":signature};
		TrustNetEX.setLicense(LICENSE);
    	//////////////////// 공통 설정 ////////////////////////////
    	TrustNetEX.setUTF8(true);	// UTF8 속성
    	//CAS Agent 설정
    	TrustNetEX.setLrapiUrl(lrapi_url);	// LRApi URL
    	TrustNetEX.setWebGWUrl(webgw_url);	// WebGW URL
    },

    methods: {
        async init() {
//CB TrustNet Client 교체 22.10.12        
//             if (!this.checkBrowser()) return;
            if (!this.checkTrustNetInstalled()) return;

            SDLUtil.showLoadingBar(true);
            const result = await this.fetchInitData();
            
            if (result) {
                const loginLock = result.loginLockYN === 'Y';
                const monthLock = result.monthLockYN === 'Y';
                // console.log('LOCKs', loginLock, monthLock);
                this.checkLock(loginLock, monthLock);
            }
            this.macAddress = SDLUtil.getMacAddress(); // requires IE!!
            // console.log('MAC ADDRESS', this.macAddress);
            SDLUtil.showLoadingBar(false);
        },

        fetchInitData() {
            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/certificate/CertIssue.skp`)
                    .then(res => {
                        console.log('CertIssue', res);
                        return res.data;
                    })
                    .catch(err => {
                        Vue.$log.error('CertIssue Err', err);
                        return err;
                    })
            );
        },

        checkBrowser() {
            if (navigator.appVersion.indexOf('MSIE') >= 0 || navigator.userAgent.indexOf('Trident') >= 0) {
                return true;
            }
            SDLUtil.alert({
                msg: 'Internet Explorer 11 is required to access this page.',
            });
            return false;
        },

        checkLock(loginLock, monthLock) {
            let msg = '';
            if (monthLock) {
                msg += "[ Unlock the 1-month lock ]<br>You haven't logged in to your account for more than a month.";
            }

            if (loginLock) {
                if (msg != '') {
                    msg += '<br>';
                }
                msg += '[ Unlock the certificate ]<br>Login failed for more than 5 times.';
            }

            msg += '<br>Please unlock the account by using Other request page.';

            const result = !(monthLock || loginLock);
            if (!result) {
                SDLUtil.alert({
                    msg,
                    onOkEvt: () => {},
                });
            }
            return result;
        },

        checkTrustNetInstalled() {
   	    	try {
   	    		$.post('https://localhost:18448/alive?'+(new Date).getTime(), {}, function(res) {})
   	    		.fail(function() {
	   	    		$.post('https://localhost:28448/alive?'+(new Date).getTime(), {}, function(res) {})
	   	    		.fail(function() {
	    	    		$.post('https://localhost:38448/alive?'+(new Date).getTime(), {}, function(res) {})
	    	    		.fail(function() {
		   	    			SDLUtil.alert({
		   	                    msg: 'Please install or allow TrustNET Solution to run.',
		   	                });
		   	                return false;
	    	    		});
	   	    		});
   	    		});
   	    	} catch (err) {
   	    		console.log('catch', err);
   	    	}
   	    	return true;
   	    	
//             if (!CertUtil.isTrustNetInstalled()) {
//                 SDLUtil.alert({
//                     msg: 'Please install or allow TrustNET Solution to run.',
//                 });
//                 return false;
//             }
//             return true;
        },

        onSubmitButtonClick() {
            if (!this.checkLock()) return;

            this.submitIssueCert()
                .catch(err => {
                    // alert('err', err);
                    Vue.$log.error('error', err);
                });
        },

        // CORE LOGIC
        async submitIssueCert() {
            if (!this.validateFormData()) return;

            const formData = this.prepFormData();

            // Checks with Server if this user is eligible for Cert
            let response = await this.postIssueYN(formData);
            // console.log('post ISSUE YN result', response);

            if (Object.prototype.hasOwnProperty.call(response, 'error')) {
                SDLUtil.alert({
                    title: 'Could not issue a certificate',
                    msg: response.error,
                });
                return;
            }
            if (response.result === false) { // Not eligible
                SDLUtil.alert({
                    title: 'Could not issue a certificate',
                    msg: response.error.replace('\n', '<br>'),
                });
                return;
            }

            const userid = response.cn;
            const username = response.uName;
            const reInsert = response.reInsert;
            const policyid = 'SCMS';

            if (formData.certPass.toUpperCase().includes(userid.toUpperCase())) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: `Certificate password cannot include '${userid}'.`,
                });
                return;
            }
          
            // // TrustNET 솔루션에서 유저등록과 인증코드를 받는 부분
            // response = await this.requestRegisterUser(userid, username, policyid);
            // // response returns {refnum, iakcode}
            // // console.log("requestRegisterUser RESPONSE: ", response);
            // if (response.result !== 0) { // 0 is good
            //     // alert('request Register User result is not 0');
            //     SDLUtil.alert({
            //         title: 'Alert',
            //         msg: `Could not register user with Certificate server. Please try again.<br>requestRegisterUser() has returned non-zero.`,
            //     });
            //     return;
            // }

            // const iakcode = response.iakcode;
            // const refnum = response.refnum;  

            //CB TrustNet Client 교체 22.10.12
            // 사용자 등록요청
            const reqUserReg = new Promise((resolve) => {
                TrustNetEX.tnRequestUserReg(userid, username, policyid, function(refnum, iakcode) {
                    //console.log('-> 참조번호 : ' + refnum);
                    //console.log('-> 인가코드 : ' + iakcode);
                    var r = {
                        'refnum': refnum,
                        'iakcode': iakcode
                    }
                    resolve(r);
                });
            })

            // 참조번호/인가코드 획득
            const retReqUserReg = await reqUserReg;
            
            let refnum = retReqUserReg.refnum.refNum;
            let iakcode = retReqUserReg.refnum.iakCode;
            console.log('refNum :' + refnum, 'iakcode : ' + iakcode);
            // 발급된 인증서 Local 저장 장치에 저장 (Handler)
            const certIssue = new Promise((resolve) => {
                TrustNetEX.tnCertIssueLocal(userid, retReqUserReg.refnum.refNum, iakcode, this.password, function(r) {
                    resolve(r);
                });
            });
            const retCertIssue = await certIssue;
            console.log('await certIssue :: '+JSON.stringify(retCertIssue));
            
            if( retCertIssue.retCode != 0){
            	SDLUtil.alert({
                    //msg: 'Please install or allow TrustNET Solution to run.',
                    msg : retCertIssue.retMsg,
                });
                return false;            	
            } else {
	            response = await this.postCertIssue(this.pin, this.password, this.macAddress, reInsert);
	            if (response.result === true) {
	                SDLUtil.alert({
	                    title: "Certificate Issued!",
	                    msg: "Certificate has been issued!",
	                    onOkEvt: () => {
	                            this.$emit('close');
	                            EventBus.$emit('cert-issued', () => {});
	                        },
	                    });
	            }
	            return 0;
            }
        },
        // CORE LOGIC
        async submitIssueCert_20221012() {
            if (!this.validateFormData()) return;

            const formData = this.prepFormData();

            // Checks with Server if this user is eligible for Cert
            let response = await this.postIssueYN(formData);
            // console.log('post ISSUE YN result', response);

            if (Object.prototype.hasOwnProperty.call(response, 'error')) {
                SDLUtil.alert({
                    title: 'Could not issue a certificate',
                    msg: response.error,
                });
                return;
            }
            if (response.result === false) { // Not eligible
                SDLUtil.alert({
                    title: 'Could not issue a certificate',
                    msg: response.error.replace('\n', '<br>'),
                });
                return;
            }

            const userid = response.cn;
            const username = response.uName;
            const reInsert = response.reInsert;
            const policyid = 'SCMS';

            if (formData.certPass.toUpperCase().includes(userid.toUpperCase())) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: `Certificate password cannot include '${userid}'.`,
                });
                return;
            }

            // TrustNET 솔루션에서 유저등록과 인증코드를 받는 부분
            response = await this.requestRegisterUser(userid, username, policyid);
            // response returns {refnum, iakcode}
            // console.log("requestRegisterUser RESPONSE: ", response);
            if (response.result !== 0) { // 0 is good
                // alert('request Register User result is not 0');
                SDLUtil.alert({
                    title: 'Alert',
                    msg: `Could not register user with Certificate server. Please try again.<br>requestRegisterUser() has returned non-zero.`,
                });
                return;
            }

            // let unetTS = this.$refs.CAClient;

            const iakcode = response.iakcode;
            const refnum = response.refnum;
            
            // const unetTS = document.getElementById('unetTS');
            const trustnetCASObj = document.getElementById("TrustNETCAClient");

            // console.log("unetTS", unetTS);
            // console.log("trustnetCASObj", trustnetCASObj);

            let hmac = trustnetCASObj.MakeHMAC(iakcode, refnum + "|" + userid);
            // console.log("hmac", hmac);
            if (hmac == null) {
                const error_code = trustnetCASObj.GetErrorCode();
                alert("Error! Failed to create HMAC1. ErrorCode : " + error_code);
                return ;
            }

            // TrustNET 솔루션에서 
            response = await this.requestCertDn(userid, refnum, hmac);
            // returns dn, hmac, keyalgo, keylength

            const dn = response.dn;
            hmac = response.hmac;
            const keyalgo = response.keyalgo;
            const keylength = parseInt(response.keylength);

            // dn과 hmac 값을 CAClient에 넘겨서 검증
            let ret = trustnetCASObj.VerifyHMAC(iakcode, refnum + "|" + dn, hmac);
            // if (ret != 0) {
            //     const error_code = trustnetCASObj.GetErrorCode();
            //     alert("Error! Failed to verify HMAC. ErrorCode : " + error_code);
            //     return;
            // }

            const certpwd = this.password;

            const csr = trustnetCASObj.GenerateCSR(dn, certpwd, keylength);
            // console.log('csr', csr);
            if (csr == null) {
                const error_code = trustnetCASObj.GetErrorCode();
                alert("Error! Failed to generate CSR. ErrorCode : " + error_code);
                return -1;
            }	
            
            // CAClient 가 id, csr, 참조번호, 인가코드를 수신하여 HMAC 값 생성
            hmac = trustnetCASObj.MakeHMAC(iakcode, refnum + "|" + userid + "|" + csr);
            if (hmac == null) {
                const error_code = trustnetCASObj.GetErrorCode();
                alert("Error! Failed to create HMAC2. ErrorCode : " + error_code);
                return -1;
            }

            response = await this.requestIssueCert(userid, refnum, hmac, csr);
            // returns cert, hmac
            if (response.result !== 0) {
                alert("error: response.error");
                return;
            }

            const cert = response.cert;

            ret = trustnetCASObj.StoreCertSet(cert);
            if (ret != 0) {
                const error_code = trustnetCASObj.GetErrorCode();
                alert("Error! Failed to save certificate. ErrorCode : " + error_code);
                return;
            }

            response = await this.postCertIssue(this.pin, this.password, this.macAddress, reInsert);
            if (response.result === true) {
                SDLUtil.alert({
                    title: "Certificate Issued!",
                    msg: "Certificate has been issued!",
                    onOkEvt: () => {
                        this.$emit('close');
                        EventBus.$emit('cert-issued', () => {});
                    },
                });
            }
            return 0;
        },

        validateFormData() {
            if(this.pin.length !== 8) {
                SDLUtil.alert({
                    title: 'Invalid PIN',
                    msg: 'Length of PIN is 8 letters.',
                });
                return false;
            }

            if (this.password.length < 8) {
                SDLUtil.alert({
                    title: 'Invalid Password',
                    msg: 'The minimum password length is 8 characters',
                });
                return false;
            }

            if (this.password !== this.passwordConfirm) {
                SDLUtil.alert({
                    title: 'Invalid Password',
                    msg: 'Passwords do not match.',
                });
                return false;
            }

            if (this.password.endsWith(' ') || this.password.startsWith(' ')) {
                SDLUtil.alert({
                    title: 'Invalid Password',
                    msg: 'Password cannot start or end with space.',
                });
                return false;
            }

            return true;
        },
        prepFormData() {
            const formData = {
                certPass: this.password,
                certPin: this.pin,
                macAddr: this.macAddress,
            };
            return formData;
        },
        postIssueYN(formData) {
            // console.log('Submitting formData:', formData);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/certificate/CertIssueYN.skp`,
                    qs.stringify(formData),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                    },
                )
                .then(res => {
                    // console.log('POST FORM RESULT =>> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('POST FORM ERROR =>> ', err);
                    return err.data;
                });

        },


        requestRegisterUser(userid, username, policyid) {
            const params = {
                cmd: 'REGISTER_USER_REGISTRATION',
                userid,
                username,
                policyid,
            };
            
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/certificate/trustNet.skp`,
                    qs.stringify(params),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                    },
                )
                .then(res => {
                    // console.log('requestRegisterUser RESULT =>> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('POST FORM ERROR =>> ', err);
                    return err.data;
                });

        },

        requestCertDn(userid, refnum, hmac) {
            const params = {
                cmd: 'REQUEST_DN',
                userid,
                refnum,
                hmac,
            };

            // console.log('requestCertDn params:', params);

            return axios.post(
                    `${SDLUtil.API_URL}/basis/certificate/trustNet.skp`,
                    qs.stringify(params),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                    },
                ).then(res => {
                    console.log('requestCertDn res: ', res);
                    return res.data;
                });

        },

        requestIssueCert(userid, refnum, hmac, csr) {
            const params = {
                cmd: 'ISSUE_CERT',
                userid,
                refnum,
                hmac,
                csr,
            };

            // console.log("requestIssueCert params:", params);

            return axios.post(
                    `${SDLUtil.API_URL}/basis/certificate/trustNet.skp`,
                    qs.stringify(params),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                    },
            ).then(res => {
                // console.log('requestIssueCert res: ', res);
                return res.data;
            });

        },

        postCertIssue(pin, passwd, macAddr, reInsert) {
            const params = {
                reInsert,
                passwd,
                macAddr,
                pin,
            };
            console.log("postCertIssue params:", params);

            return axios.post(
                    `${SDLUtil.API_URL}/basis/certificate/CertIssueProc.skp`,
                    qs.stringify(params),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                    },
            ).then(res => {
                // console.log('requestIssueCert res: ', res);
                return res.data;
            });

        },


    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/certificate/CertIssuePopup.vue